<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <div v-if="canManageEmployees()" class="container pt-4">
            <ButtonTag :is-tw-main-btn="true" url="employees/positions/add" :is-w100="false">
                <div class="pt-1">{{ $t('add') }}</div>
            </ButtonTag>
        </div>

        <TableTag
            class="w-full"
            getter-name="getEmployeePositions"
            :headers="['id', 'name', 'actions']"
            :body-properties="['id', 'name', 'actions']"
        >
            <template v-slot:actions="row">
                <img src="/images/edit.png" @click="$i18nHelper.toUrl('employees/positions/' + row.item.id)" alt="" class="h-6 pr-3 cursor-pointer">
                <img v-if="canManageEmployees()" src="/images/Union.png" @click="$bvModal.show('delete-position-' + row.item.id)" alt="" class="h-7 cursor-pointer">

                <Modal
                    text="deleteConfirm"
                    ok-text="yes"
                    cancel-text="no"
                    :is-ok-only="false"
                    :context="{name: row.item.name}"
                    :id="'delete-position-' + row.item.id"
                    :on-ok-pressed="() => {modalOk(row.item.id)}"
                />
            </template>
        </TableTag>

        <RowColumn class="mt-4 ml-3">
            <Pagination
                :search="{page: 1}"
                base-url="employees/positions"
                method-name="fetchEmployeePositions"
                :total-items="getEmployeePositionsTotalCount"
            />
        </RowColumn>
    </Row>
</template>

<script>
import Row from "@/components/html/Row";
import {mapActions, mapGetters} from "vuex";
import TableTag from "@/components/html/TableTag";
import RowColumn from "@/components/RowColumn";
import Pagination from "@/components/html/Pagination";
import ButtonTag from "@/components/html/ButtonTag";
import accessMixin from "@/mixin/accessMixin";
import Modal from "@/components/html/Modal";

export default {
    name: "EmployeePositionsList",
    mixins: [accessMixin],
    components: {ButtonTag, Pagination, RowColumn, TableTag, Row, Modal},
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'employee.title', url: 'employees'},
                {name: 'employee.position'},
            ],
        }
    },
    computed: {
        ...mapGetters(['getEmployeePositions', 'getEmployeePositionsTotalCount'])
    },
    methods: {
        ...mapActions(['deleteEmployeePosition','fetchEmployeePositions', 'setBreadcrumbItems']),
        modalOk(id) {
            this.deleteEmployeePosition(id)
                .then(() => {
                    this.fetchEmployeePositions({page: 1})
                })
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    }
}
</script>

<style scoped>

</style>
